import { render, staticRenderFns } from "./lose.vue?vue&type=template&id=408554a2&scoped=true"
import script from "./lose.vue?vue&type=script&lang=js"
export * from "./lose.vue?vue&type=script&lang=js"
import style0 from "./lose.vue?vue&type=style&index=0&id=408554a2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408554a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408554a2')) {
      api.createRecord('408554a2', component.options)
    } else {
      api.reload('408554a2', component.options)
    }
    module.hot.accept("./lose.vue?vue&type=template&id=408554a2&scoped=true", function () {
      api.rerender('408554a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/lose.vue"
export default component.exports